export let map = null
export const setMap = newMap => map = newMap



// WEBPACK FOOTER //
// ./app/map/index.js